import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        filter: '=',
        defaultFilter: '='
    },
    template: `
        <form ng-submit="vm.submitFilter()">
            <div class="form form-filter">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'performanceReview.Employee name' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.userId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find an employee')"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'filter.Employee department' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.departmentId"
                                ng-options="item.id as item.value for item in vm.departments">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'filter.Employee role' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.roleId"
                                ng-options="item.id as item.value for item in vm.roles">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'filter.Employee level' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.levelId"
                                ng-options="item.id as item.value for item in vm.levels">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'performanceReview.Direct manager' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedManager"
                                ng-model="vm.filter.directManagerId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find a manager')"
                                query="vm.queryManagers(input)"
                            />
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Development field' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.developmentField" class="form-control">
                        </select>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Actions' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.action" class="form-control">
                        </select>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($translate, SiteService, FilterService, UserResource, ClassifierResource, lodash,
                 ROLE_COMPANY_MODULE_PRIVILEGE_ENUM, ROLE_CODE_ENUM, REVIEW_STATUS_ENUM, CLASSIFIER_ENUM) {
        this.$translate = $translate;
        this.SiteService = SiteService;
        this.FilterService = FilterService;
        this.UserResource = UserResource;
        this.ClassifierResource = ClassifierResource;
        this.lodash = lodash;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.statuses = REVIEW_STATUS_ENUM.KEY_LABEL_PAIRS;
    }

    $onInit () {
        this.ClassifierResource.query({ pageSize: 0 }).$promise.then((classifiers) => {
            this.departments = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
            this.roles = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
            this.levels = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        });

        this.filterTranslations = this.FilterService.getTranslations();
        this.initMultiFilter();
    }

    initMultiFilter () {
        const siteOptions = this.SiteService.getSitesByPrivileges([this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PERFORMANCE_REVIEW_MANAGE], true)
            .map(site => {
                return {
                    value: site.id,
                    label: site.name
                };
            });
        const siteOptionsSelected = siteOptions.map(site => site);

        this.multiFilter = {
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    queryUsers (input) {
        const siteIds =
            this.SiteService.getSitesByPrivileges([this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM.KEYS.PERFORMANCE_REVIEW_MANAGE], true)
                .map(site => site.id);

        const params = {
            roleCode: this.ROLE_CODE_ENUM.EMPLOYEE,
            name: input,
            'siteIds[]': siteIds
        };

        return this.UserResource.query(params).$promise;
    }

    queryManagers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            name: input,
            pageSize: 0
        };
        const siteIds = this.multiFilter.sites.model.map(site => site.value);
        if (siteIds) {
            params['siteIds[]'] = siteIds;
        }
        return this.UserResource.query(params).$promise;
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.selectedEmployee = null;
        this.selectedManager = null;
        this.submitFilter();
    }

    submitFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        this.filter = this.lodash.assign(this.filter, { 'siteIds[]': siteIds });

        this.list.fetch(this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/developmentPlan/filter/index.js